import React, { CSSProperties, FC } from 'react'

import Container from '@Components/CMS/Container'

import styles from './Loading.module.scss'

interface LoadingInnerProps {
  className?: string
  height: number
  id?: string
}

interface LoadingProps extends LoadingInnerProps {
  width: 'small' | 'medium' | 'wide'
}

export const Loading: FC<LoadingProps> = ({ className, height, id, width }) => (
  <Container className={className} id={id} width={width}>
    <div className={styles.styles} style={height ? { height: `${height}px` } : {} as CSSProperties}>
      <div className={styles.spinner} />
    </div>
  </Container>
)
